import PackageData from './PackageData';
import { usePackagesContext } from '../../../context/packages_context';
import MiniLoader from '../../../utils/MIniLoader';
import EmptyData from '../../EmptyData';


const MonthlyPackages = () => {

    const {
        monthlyPackagesLoading, allMonthlyPackages,
    } = usePackagesContext();

    return (
        <>

            <div className="d-flex justify-content-center">
                <MiniLoader
                    load={monthlyPackagesLoading}
                />
            </div>
            <EmptyData
                data={allMonthlyPackages}
                title='Packages'
            />

            <div className="row my-5">
                <PackageData
                    allPackages={allMonthlyPackages}
                />
            </div>

        </>
    );
};

export default MonthlyPackages;